import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {TableBoName} from "../enums/table-bo-name.enum";
import {UserMinAdmin} from "../Models/UserMinAdmin";

@Component({
	selector: 'app-all-users',
	templateUrl: './all-users.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./all-users.component.less']
})
export class AllUsersComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	textes: any;
	users: UserMinAdmin[] = []
	originalUsers: UserMinAdmin[] = [];
	searchTerm: string = '';
	tabOptions: any = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	userId: any = localStorage.getItem('user_id');

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Remove the modalOpen from localStorage to avoid problems
		localStorage.removeItem("modalOpen");

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the Users
		this.getAllUsers();

		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get the modal texts
					this.app.dataInitService.getModalTextsOnce(modalsTxt => {
						this.modalsTxt = modalsTxt;
					});

					// Set the pagination labels
					this.app.previousLabelTxt = this.app.sharedToolsService.getPaginationLabels('prev');
					this.app.nextLabelTxt = this.app.sharedToolsService.getPaginationLabels('next');
				})
			})
	}

	getAllUsers(){
		this.app.apiToolsService.getAllUsers().subscribe(
			(users: UserMinAdmin[]) => {
				console.log("getAllUsers ==> ", users);
				this.users = users;
				this.originalUsers = users;

				this.app.sharedToolsService.sortTable(this.tabOptions.sortKey, this.users, this.tabOptions);
			}
		)
	}

	search() {
		if (this.searchTerm) {

			this.users = this.app.sharedToolsService.searchInTable(this.searchTerm, this.originalUsers, [], this.textes.blocTable.cols);
		} else {
			this.users = [...this.originalUsers];
		}
		this.tabOptions = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	}
}
